// notesCache keeps the focus-mode notes persistence logic in one place.
// Each function wraps localStorage access with error handling so we never
// leave inconsistent data if the browser throws.

const NOTES_STORAGE_KEY = 'goalie4-focus-notes';

function readStore(): Record<string, string> {
  if (typeof window === 'undefined') {
    return {};
  }
  try {
    const raw = localStorage.getItem(NOTES_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Record<string, string>) : {};
  } catch (error) {
    console.error('Failed to read stored focus notes:', error);
    return {};
  }
}

function writeStore(notes: Record<string, string>) {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    if (Object.keys(notes).length === 0) {
      localStorage.removeItem(NOTES_STORAGE_KEY);
    } else {
      localStorage.setItem(NOTES_STORAGE_KEY, JSON.stringify(notes));
    }
  } catch (error) {
    console.error('Failed to persist focus notes:', error);
  }
}

export function getStoredNote(userId: string, taskId: string): string | undefined {
  const key = `${userId}:${taskId}`;
  const store = readStore();
  return store[key];
}

export function upsertStoredNote(userId: string, taskId: string, note: string) {
  const key = `${userId}:${taskId}`;
  const store = readStore();
  if (!note.trim()) {
    if (store[key]) {
      delete store[key];
      writeStore(store);
    }
    return;
  }
  store[key] = note;
  writeStore(store);
}

export function clearStoredNote(userId: string, taskId: string) {
  const key = `${userId}:${taskId}`;
  const store = readStore();
  if (store[key]) {
    delete store[key];
    writeStore(store);
  }
}
